import React from 'react';
import './style.css';
import Card from './Card';

function App() {
    return (
        <div className="App">
            <Card />
        </div>
    );
}

export default App;
